import React from "react";
import { ControlLabel, Button, Alert, FormControl, Checkbox } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import DatePicker from "react-bootstrap-date-picker";

export default class AddNews extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();
        
        this.state = {
            idValue: '',
            title: '',
            titleLabel: '',
            subTitleLabel: '',
            dateLabel: '',
            stickyLabel: '',
            contentShortLabel: '',
            contentLongLabel: '',
            saveLabel: '',
            cancelLabel: '',
            addNewLabel: '',
            deleteLabel: '',
            confirmDeleteLabel: '',
            requiredLabel: '',
            errors: [],
            titleValue: '',
            subTitleValue: '',
            publishedDate: '',
            publishedDateValue: '',
            stickyValue: "false",
            contentShortValue: '',
            contentLongValue: '',
            deleteDisabled: true,
            alertStyle: ''
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.onSubTitleChange = this.onSubTitleChange.bind(this);
        this.onPublishedDateChange = this.onPublishedDateChange.bind(this);
        this.onPublishedDateBlur = this.onPublishedDateBlur.bind(this);
        this.onStickyChange = this.onStickyChange.bind(this);
        this.onContentShortChange = this.onContentShortChange.bind(this);
        this.onContentLongChange = this.onContentLongChange.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    setEditValues(news) {
        self = this;
        
        var publishedDateISO = '';
        var publishedDateFormatted = '';
        if (news.formattedPublishedDate != '') {
            publishedDateISO = new Date(news.formattedPublishedDate).toISOString();
            publishedDateFormatted = news.formattedPublishedDate.split(' ')[0];
        }

        self.setState({
            titleValue: news.title,
            subTitleValue: news.subTitle,
            publishedDate: publishedDateISO,
            publishedDateValue: publishedDateFormatted,
            contentShortValue: news.contentShort,
            contentLongValue: news.contentLong,
            stickyValue: news.sticky
        });

        if (news.sticky == true) {
            document.getElementById('sticky-checkbox').checked = true;
        }
    }

    loadViewModel() {
        let self = this;
        let path = this.props.location.pathname.split('/');
        let id = '';
        let deleteButton = true;
        
        if (!isNaN(parseInt(path[path.length - 1]))) {
            if (path[path.length - 1] != '0') {
                id = path[path.length - 1];
                deleteButton = false;
            }
        }

        self.setState({
            idValue: id,
            deleteDisabled: deleteButton
        });

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`add-news/${id}`)
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    titleLabel: res.data.titleLabel,
                    subTitleLabel: res.data.subTitleLabel,
                    dateLabel: res.data.dateLabel,
                    stickyLabel: res.data.stickyLabel,
                    contentShortLabel: res.data.contentShortLabel,
                    contentLongLabel: res.data.contentLongLabel,
                    saveLabel: res.data.saveLabel,
                    backLabel: res.data.backLabel,
                    addNewLabel: res.data.addNewLabel,
                    deleteLabel: res.data.deleteLabel,
                    confirmDeleteLabel: res.data.confirmDeleteLabel,
                    requiredLabel: res.data.requiredLabel
                });

                if (res.data.news.id !== undefined) {
                    if (res.data.news.id > 0) {
                        self.setEditValues(res.data.news);
                    }
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onSave() {
        var messages = this.validate();

        this.setState({
            errors: messages,
            alertStyle: 'danger'
        });

        if (messages.length == 0) {
            this.save();
        }
    }

    save() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        var newsParam = {
            Id: self.state.idValue,
            Title: self.state.titleValue,
            SubTitle: self.state.subTitleValue,
            PublishedDate: self.state.publishedDateValue,
            Sticky: self.state.stickyValue,
            ContentShort: self.state.contentShortValue,
            ContentLong: self.state.contentLongValue
        };
        
        self.setState({
            errors: []
        });

        if (self.state.idValue == '') {
            ajax.api().put(`add-news`, newsParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            idValue: res.data.id,
                            errors: msg,
                            deleteDisabled: false,
                            alertStyle: 'success'
                        });
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
        else {
            ajax.api().post('edit-news', newsParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });    
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    validate() {
        let msg = [];

        var startDate = this.getFormattedDate("publisheddate-datepicker");
        if (startDate.length == 0) {
            msg.push(this.state.dateLabel + ' ' + this.state.requiredLabel);
            this.setState({
                publishedDate: null,
                publishedDateValue: ''
            });
        }

        return msg;
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/manage-news';
    }

    onAddNew() {
        let self = this;
        window.location = context.root() + '/app/add-news/0';
    }

    onDelete() {
        self = this;

        self.setState({
            errors: []
        });

        if (confirm(self.state.confirmDeleteLabel) == true) {
            context.message({
                show: true, 
                type: "loading", 
                message:"Loading. Please wait..."
            });

            ajax.api().post(`delete-news/${this.state.idValue}`)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            idValue: '',
                            deleteDisabled: true,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onTitleChange(event) {
        let value = event.target.value;

        this.setState({
            titleValue: value
        });
    }

    onSubTitleChange(event) {
        let value = event.target.value;

        this.setState({
            subTitleValue: value
        });
    }

    onPublishedDateChange(value, formattedValue) {
        this.setState({
            publishedDate: value,
            publishedDateValue: formattedValue
        });
    }

    onPublishedDateBlur() {
        if (this.getFormattedDate('publisheddate-datepicker') == '') {
            this.setState({
                publishedDate: null,
                publishedDateValue: ''
            });
        }
    }

    onStickyChange(event) {
        let value = event.target.checked;

        this.setState({
            stickyValue: value
        });
    }

    onContentShortChange(event) {
        let value = event.target.value;

        this.setState({
            contentShortValue: value
        });
    }

    onContentLongChange(event) {
        let value = event.target.value;

        this.setState({
            contentLongValue: value
        });
    }

    getFormattedDate(id) {
        return document.getElementById(id).getAttribute("data-formattedvalue").trim(); // accessed value from dom because handle change isn't fired when removed
    }

    render() {
        var rowPaddingTopStyle = {
            "padding-top": "10px"
        };

        var requiredStyle = {
            "color": "red"
        };

        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.titleLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.titleValue}
                                onChange={this.onTitleChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.subTitleLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.subTitleValue}
                                onChange={this.onSubTitleChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.dateLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <DatePicker id="publisheddate-datepicker" 
                                placeholder="MM/DD/YYYY" 
                                value={this.state.publishedDate}
                                onChange={this.onPublishedDateChange}
                                onBlur={this.onPublishedDateBlur} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.stickyLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <Checkbox id="sticky-checkbox" name="sticky-checkbox" onChange={this.onStickyChange} 
                                value={this.state.stickyValue}></Checkbox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.contentShortLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl componentClass="textarea" rows="5"
                                value={this.state.contentShortValue}
                                onChange={this.onContentShortChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.contentLongLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl componentClass="textarea" rows="10"
                                value={this.state.contentLongValue}
                                onChange={this.onContentLongChange}></FormControl>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-3 col-lg-3"></div>
                        <div className="col-md-3 col-lg-9">
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onSave} className="btn-info ap-fullsize" >{this.state.saveLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onBack} className="btn-info ap-fullsize" >{this.state.backLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onAddNew} className="btn-info ap-fullsize" >{this.state.addNewLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onDelete} className="btn-info ap-fullsize" disabled={this.state.deleteDisabled}>{this.state.deleteLabel}</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                        <div className="col-md-12 col-lg-12">
                            <div className="col-md-12 col-lg-12">
                                <Alert bsStyle={this.state.alertStyle} className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                    <ul>
                                        {this.state.errors.map(m =>
                                            <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}